import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { LOCAL__ui_set_boolean } from '@/state/ui/_base/LOCAL__ui_set_boolean';

export function BUTTON__image_compare_close() {
  const dispatch = use_dispatch();

  const { global__grid2d_show_as_gallery } = use_slice_ui(['global__grid2d_show_as_gallery']);
  /*
   *
   */
  function onClick() {
    dispatch(LOCAL__ui_set_boolean({ key: 'global__grid2d_show_as_gallery', value: false }));
  }

  /*
   *
   */
  function is_disabled() {
    return !global__grid2d_show_as_gallery;
  }
  /*
   *
   */

  return (
    <UI_PRIMITIVE__button
      disabled={is_disabled()}
      {...{ onClick }}
      className={` relative h-6  text-component-foreground text-xs w-full`}
      variant="outline-on-component"
    >
      Close
    </UI_PRIMITIVE__button>
  );
}
